import produce from "immer";
import {
  MARK_AS_READ,
  MARK_AS_READ_LATER,
  MARK_AS_SKIPPED,
  MARK_AS_UNREAD,
  MARK_PREVIOUS_AS_READ,
  MARK_PREVIOUS_AS_READ_LATER,
  MARK_PREVIOUS_AS_SKIPPED,
  RESET_READING,
  SET_ORDER_POSITION,
  SET_PREVIOUS_COMICS,
  SYNC_READING,
} from "./actions";

const initialState = {
  readings: {},
};

function toggleRead(state, action, read) {
  return produce(state, (draftState) => {
    draftState.readings[action.payload.readingId].comics = state.readings[
      action.payload.readingId
    ].comics.map((comic) => {
      return comic.id === action.payload.comicId &&
        comic.story === action.payload.story
        ? {
            ...comic,
            read,
            skipped: 0,
            readLater: 0,
          }
        : comic;
    });
  });
}

function toggleSkipOrReadLater(state, action, skipped, readLater) {
  return produce(state, (draftState) => {
    draftState.readings[action.payload.readingId].comics = state.readings[
      action.payload.readingId
    ].comics.map((comic) => {
      return comic.id === action.payload.comicId &&
        comic.story === action.payload.story
        ? {
            ...comic,
            skipped,
            readLater,
            read: skipped || readLater ? 0 : comic.read,
          }
        : comic;
    });
  });
}

function markAllPreviousAs(state, action, read, skipped, readLater) {
  return produce(state, (draftState) => {
    draftState.readings[action.payload.readingId].comics = draftState.readings[
      action.payload.readingId
    ].comics.map((item) => {
      if (draftState.readings[action.payload.readingId].orderPosition) {
        // Any item between my last jump and my next jump: update statuses only if not read/skipped/read later already.
        return draftState.readings[action.payload.readingId].orderPosition >
          item.order &&
          !item.read &&
          !item.skipped &&
          !item.readLater
          ? { ...item, read, skipped, readLater }
          : item;
      }

      return item.order < action.payload.order
        ? { ...item, read, skipped, readLater }
        : item;
    });
  });
}

function orderReducer(state = initialState, action) {
  switch (action.type) {
    case SYNC_READING:
      return {
        ...state,
        readings: {
          ...state.readings,
          [action.payload.readingId]: {
            ...state.readings[action.payload.readingId],
            lastUpdated: new Date(),
            comics: action.payload.data,
          },
        },
      };
    case SET_PREVIOUS_COMICS:
      return {
        ...state,
        readings: {
          ...state.readings,
          [action.payload.readingId]: {
            ...state.readings[action.payload.readingId],
            comics: [
              ...action.payload.data,
              ...state.readings[action.payload.readingId].comics,
            ],
          },
        },
      };
    case MARK_AS_SKIPPED:
      return toggleSkipOrReadLater(state, action, 1, 0);
    case MARK_AS_READ_LATER:
      return toggleSkipOrReadLater(state, action, 0, 1);
    case MARK_AS_READ:
      return toggleRead(state, action, 1);
    case MARK_AS_UNREAD:
      return toggleRead(state, action, 0);
    case SET_ORDER_POSITION:
      return {
        ...state,
        readings: {
          ...state.readings,
          [action.payload.readingId]: {
            ...state.readings[action.payload.readingId],
            orderPosition: action.payload.orderPosition || 0,
          },
        },
      };
    case MARK_PREVIOUS_AS_READ:
      return markAllPreviousAs(state, action, 1, 0, 0);
    case MARK_PREVIOUS_AS_SKIPPED:
      return markAllPreviousAs(state, action, 0, 1, 0);
    case MARK_PREVIOUS_AS_READ_LATER:
      return markAllPreviousAs(state, action, 0, 0, 1);
    case RESET_READING:
      return {
        ...state,
        readings: {
          ...state.readings,
          [action.payload.readingId]: {
            ...state.readings[action.payload.readingId],
            comics: state.readings[action.payload.readingId].comics.map(
              (item) => ({
                ...item,
                read: 0,
                skipped: 0,
                readLater: 0,
                readingDate: null,
                readingDateFormatted: null,
              })
            ),
            orderPosition: 0,
          },
        },
      };
    default:
      return state;
  }
}

export default orderReducer;
